import { DEFECT_STATUSES, OVERDUE_STATUS } from './constants'

import { Pill } from '@/components/shared-components/BUI/Pill'
import { useLocale } from '@/context/localeContext'

import { DefectStatus } from 'types/api.graphql'

export const getStatusText = (
  status: DefectStatus,
  showCategory: boolean,
  t: ReturnType<typeof useLocale>['t']
) => {
  const statusBits = DEFECT_STATUSES[status]

  if (!statusBits.category || !showCategory) return t(statusBits.labelPath)
  return `${statusBits.category}: ${t(statusBits.labelPath)}`
}

type Props = {
  status: DefectStatus
  className?: string
  showCategory?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const DefectStatusTag: React.FC<Props> = ({
  status,
  size = 'small',
  showCategory = true,
  className,
}) => {
  const { t } = useLocale()
  const statusConfig = DEFECT_STATUSES[status] || OVERDUE_STATUS

  return (
    <Pill
      label={getStatusText(status, showCategory, t)}
      icon={statusConfig.icon}
      variant={statusConfig.variant}
      size={size}
      className={className}
      whiteBg
    />
  )
}
